// extracted by mini-css-extract-plugin
export var bubble = "_2f-0";
export var container = "_2f-f";
export var contrastBorder = "_2f-g";
export var greyOut = "_2f-2";
export var initialsColor0 = "_2f-3";
export var initialsColor1 = "_2f-4";
export var initialsColor10 = "_2f-d";
export var initialsColor11 = "_2f-e";
export var initialsColor2 = "_2f-5";
export var initialsColor3 = "_2f-6";
export var initialsColor4 = "_2f-7";
export var initialsColor5 = "_2f-8";
export var initialsColor6 = "_2f-9";
export var initialsColor7 = "_2f-a";
export var initialsColor8 = "_2f-b";
export var initialsColor9 = "_2f-c";
export var initialsWrapper = "_2f-1";
export var large = "_2f-l";
export var medium = "_2f-k";
export var mediumSmall = "_2f-j";
export var mediumSmallMedium = "_2f-o";
export var micro = "_2f-h";
export var small = "_2f-i";
export var tiny = "_2f-n";
export var xTiny = "_2f-m";